import { Typography } from "@mui/material";

export function Roles(){
  return(
    <Typography variant="h4" fontWeight={700} sx={{textAlign:"center"}}>Roles</Typography>

  )
}